import axios from 'axios'
import Vue from 'vue'
import {
    Message,
    Loading
} from 'element-ui'
import {
    bus
} from '@/main.js'
// 全局 loading 实例
let loading = null

// 创建 axios 实例
const service = axios.create({
    // 基础接口地址
    baseURL: "https://hrxsl.com",
    // 超时时间
    timeout: 30000,
    // 请求头
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    }
})

// ==================== 请求拦截器 ====================
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.token = token || ''
            config.headers.source = 'pc'
        } else {
            config.headers.source = 'pc'
        }

        return config
    },
    error => {
        loading && loading.close()
        return Promise.reject(error)
    }
)

// ==================== 响应拦截器 ====================
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code == -2) {
            localStorage.removeItem('token')
            Vue.prototype.$bus.$emit('openLoginModal')
        }

        if (res.code == -1) {
            window.location.href = "https://hrxsl.com/personVerify"
        }
        return res
    },
    error => {
        loading && loading.close()
        // 网络错误、状态码判断
        let msg = ''
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    msg = '登录已失效，请重新登录'
                    // 可在这里清空token、跳转到登录页
                    localStorage.removeItem('token')
                    window.location.href = '/login'
                    break
                case 403:
                    msg = '权限不足'
                    break
                case 404:
                    msg = '接口不存在'
                    break
                case 500:
                    msg = '服务器内部错误'
                    break
                default:
                    msg = `请求错误 ${error.response.status}`
            }
        } else {
            msg = '网络异常，请检查网络'
        }

        Message({
            message: msg,
            type: 'error',
            duration: 2000
        })
        return Promise.reject(error)
    }
)

export default service